module.exports = __webpack_public_path__ + "static/img/playTech.a3c6ab5.webp";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/footer/playTech.webp
// module id = eEeu
// module chunks = 3